
import { MongoView } from "@/models/mongo-view";
import { IAvailableMongoViewColumn } from "@/utils/mongo-view/mongo-view-column";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppColumnsEdit from "./ColumnsEdit.vue";
import { MongoViewService } from "@/services/mongo-view-service";
import { isStringNullOrWhitespace } from "@/utils/strings";
import { Contact } from "@/models/base";
import AppContactSearch from "@/components/contacts/ContactSearch.vue";
import { SupplierService } from "@/services/supplier-service";

export default Vue.extend({
	data(){
		return {
			isSaving: false,
			supplier: null as null | Contact
		};
	},
	props: {
		view: {
			type: Object as ()=>MongoView,
			required: true
		},
		availableColumns: {
			type: Array as ()=>IAvailableMongoViewColumn[],
			required: true
		},
		supplierFilter: Boolean
	},
	computed: {
		title():TranslateResult {
			if (this.view.ID == 0) {
				return this.$ct("new-view");
			}
			return this.$ct("edit-view");
		},
		valid():boolean {
			return this.view.Columns.length > 0 && !isStringNullOrWhitespace(this.view.Name);
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		onSupplierSelect(supplier:Contact | null){
			this.view.SupplierNR = supplier ? supplier.ComputedFriendlyID : "";
		},
		clearSupplier(){
			this.supplier = null;
			this.view.SupplierNR = "";
		},
		async save(){
			if (this.isSaving) return;
			try{
				this.isSaving = true;
				if (this.view.ID) {
					await MongoViewService.updateView(this.view);
				}else{
					await MongoViewService.createView(this.view);
				}
				this.close();
			}catch(err){

			}finally{
				this.isSaving = false;
			}
		}
	},
	async created(){
		if (!this.supplierFilter || !this.view.SupplierNR) return;
		try{
			this.supplier = await SupplierService.getByComputedFriendlyId(this.view.SupplierNR);
		}catch(err){
			this.supplier = null;
		}
	},
	components: {
		AppColumnsEdit,
		AppContactSearch
	},
	i18nEx: {
		componentPrefix: "components.mongo-view-editor"
	}
});
